import { render, staticRenderFns } from "./DetailsRecurrence.vue?vue&type=template&id=f2fa266e"
import script from "./DetailsRecurrence.vue?vue&type=script&lang=js"
export * from "./DetailsRecurrence.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports